module.exports = __webpack_public_path__ + "static/media/19-14.422a469e.mp3";